import { render, staticRenderFns } from "./ListStartPoint.vue?vue&type=template&id=26a07b26&"
import script from "./ListStartPoint.vue?vue&type=script&lang=js&"
export * from "./ListStartPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports